import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './UserProfileForm.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

const CreateUser = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: '',
    middle_name: '',
    last_name: '',
    email: '',
    password: '',
    confirmPassword: '',
    telephone_number: '',
    gender: '',
    date_of_birth: '',
    address: '',
    city: '',
    state_province: '',
    zip_code: '',
    country: '',
    nationality: '',
    role_id: '2',
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/users/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          role_id: parseInt(formData.role_id, 10),
        }),
      });

      const result = await res.json();
      if (!res.ok) {
        throw new Error(result.message || 'Registration failed');
      }

      setSuccess('User created successfully!');
      setTimeout(() => navigate('/admin/users'), 1500);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="user-profile-form">
      <h2>Create New User</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-field"><label>First Name</label>
          <input name="first_name" value={formData.first_name} onChange={handleChange} required />
        </div>
        <div className="form-field"><label>Middle Name</label>
          <input name="middle_name" value={formData.middle_name} onChange={handleChange} />
        </div>
        <div className="form-field"><label>Last Name</label>
          <input name="last_name" value={formData.last_name} onChange={handleChange} required />
        </div>
        <div className="form-field"><label>Email</label>
          <input name="email" type="email" value={formData.email} onChange={handleChange} required />
        </div>
        <div className="form-field"><label>Password</label>
          <input
            name="password"
            type={showPassword ? 'text' : 'password'}
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-field"><label>Confirm Password</label>
          <input
            name="confirmPassword"
            type={showPassword ? 'text' : 'password'}
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-field"><label>Telephone</label>
          <input name="telephone_number" value={formData.telephone_number} onChange={handleChange} />
        </div>
        <div className="form-field"><label>Gender</label>
          <select name="gender" value={formData.gender} onChange={handleChange}>
            <option value="">Select</option>
            <option>Male</option>
            <option>Female</option>
            <option>Other</option>
          </select>
        </div>
        <div className="form-field"><label>Date of Birth</label>
          <input name="date_of_birth" type="date" value={formData.date_of_birth} onChange={handleChange} />
        </div>
        <div className="form-field"><label>Address</label>
          <input name="address" value={formData.address} onChange={handleChange} />
        </div>
        <div className="form-field"><label>City</label>
          <input name="city" value={formData.city} onChange={handleChange} />
        </div>
        <div className="form-field"><label>State/Province</label>
          <input name="state_province" value={formData.state_province} onChange={handleChange} />
        </div>
        <div className="form-field"><label>ZIP Code</label>
          <input name="zip_code" value={formData.zip_code} onChange={handleChange} />
        </div>
        <div className="form-field"><label>Country</label>
          <input name="country" value={formData.country} onChange={handleChange} />
        </div>
        <div className="form-field"><label>Nationality</label>
          <input name="nationality" value={formData.nationality} onChange={handleChange} />
        </div>
        <div className="form-field"><label>Role</label>
          <select name="role_id" value={formData.role_id} onChange={handleChange}>
            <option value="2">ERC Staff</option>
            <option value="3">Reviewer</option>
            <option value="4">Secretary</option>
          </select>
        </div>
        <button className="action-button" type="submit">Create User</button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {success && <p style={{ color: 'green' }}>{success}</p>}
      </form>
    </div>
  );
};

export default CreateUser;
